/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Password_ShowInputs */

const en_auth_password_show = /** @type {(inputs: Auth_Password_ShowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show password`)
};

const pl_auth_password_show = /** @type {(inputs: Auth_Password_ShowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokaż hasło`)
};

/**
* | output |
* | --- |
* | "Show password" |
*
* @param {Auth_Password_ShowInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_password_show = /** @type {((inputs?: Auth_Password_ShowInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Password_ShowInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_password_show(inputs)
	return en_auth_password_show(inputs)
});